var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppView',{staticClass:"winners"},[_c('h1',[_vm._v(_vm._s(_vm.$t('app.winners')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('app.winnersList'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }